// extracted by mini-css-extract-plugin
export default {"ShopItemBreadcrumb":"ShopItemBreadcrumb_ShopItemBreadcrumb__WNVhE"};